import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import Dropdown from "components/Dropdown";
import TextArea from "components/TextArea";
import ModalGeneralSuccessfully from "screens/ModalGeneralSuccessfully";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { CREATE_CHARGE } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import colors from "constants/colors";

const ModalDelayedCharge = ({
  hidden,
  buttonStyle,
  billId,
  cardNumber,
  bookings
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [chargeAmount, setChargeAmount] = useState("");
  const [inputError, setInputError] = useState(false);

  const [chargeDetails, setChargeDetails] = useState("");
  const [textAreaError, setTextAreaError] = useState(false);

  const [chargeType, setChargeType] = useState("");
  const [chargeTypeError, setChargeTypeError] = useState(false);

  const optionArray =
    bookings?.map((booking) => {
      return {
        label: `Room ${booking.roomBookings?.[0]?.room?.roomNumber}`,
        value: booking.bookingId,
      };
    }) || [];

  const [selectedBookingId, setSelectedBookingId] = useState("");
  const [bookingIdError, setBookingIdError] = useState(false);

  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);

  const [createCharge, { loading }] = useMutation(CREATE_CHARGE, {
    onCompleted: () => {
      setSuccessfullyIsOpen(true);
      setFailedIsOpen(false);
      setIsOpen(false);
    },
    onError: (error) => {
      setFailedIsOpen(true);
      setIsOpen(false);
    },
  });

  const handleDelayedCharge = () => {
    if (loading) return;
    let error = false;

    if (chargeAmount === "") {
      setInputError(true);
      error = true;
    }

    if (chargeType === "") {
      setChargeTypeError(true);
      error = true;
    }

    if (selectedBookingId === "") {
      setBookingIdError(true);
      error = true;
    }

    if (chargeDetails === "") {
      setTextAreaError(true);
      error = true;
    }

    if (error) return;

    createCharge({
      variables: {
        input: {
          billId: billId,
          type: "CHARGE",
          amount: Number(chargeAmount),
          chargeType: chargeType.toUpperCase().replace(/ /g, "_"),
          bookingId: selectedBookingId,
          description: chargeDetails,
        },
      },
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Delayed Charge"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Delayed Charge</Head>
        <Container>
          <div className="groupTitle">
            {`This booking has already completed it’s checkout. This form will create a new charge against the customer’s card ending in ${cardNumber?.slice(
              -4
            )}. This will create an entirely new bill for this new charge. Once complete the charge and the bill will be displayed in the transactions section of this booking.`}
          </div>
          <div className="inputRow">
            <Input
              title="CHARGE AMOUNT"
              required
              error={inputError}
              errorMessage="Please enter a valid amount"
              value={chargeAmount}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(inputValue)) {
                  setChargeAmount(inputValue);
                  setInputError(false);
                }
              }}
              additionalstyle={`
              width: calc(50% - 8px);

              input {
                padding-left: 22px;
              }

              ::before {
                content: '$';
                font-size: 16px;
                font-weight: 600;
                position: absolute;
                color: ${colors.white};
                left: 12px;
                top: 32px;
              }

              .warning {
                white-space: nowrap;
              }
            `}
            />
          </div>
          <div className="inputRow">
            <Dropdown
              title="CHARGE TYPE"
              required
              options={[
                "Lodging",
                "Early Check-In",
                "Late Check-Out",
                "Parking",
                "Food & Beverage",
                "Room Service",
                "Damages",
                "Missing Items",
                "Misc Fees",
              ]}
              value={chargeType}
              placeholder="-Select-"
              error={chargeTypeError}
              onChange={(e) => setChargeType(e)}
              additionalstyle={`
                width: 50%;
              `}
            />
            <Dropdown
              title="APPLY TO ROOM"
              required
              options={optionArray}
              value={
                optionArray.find((o) => o.value === selectedBookingId)?.label ||
                ""
              }
              placeholder="-Select-"
              error={bookingIdError}
              onChange={(e) => setSelectedBookingId(e)}
              additionalstyle={`
                width: 50%;
              `}
            />
          </div>
          <TextArea
            title="CHARGE DETAILS"
            required
            rows={4}
            error={textAreaError}
            value={chargeDetails}
            onChange={(e) => {
              setChargeDetails(e.target.value);
              setTextAreaError(false);
            }}
            additionalstyle={`
              flex-basis: 100%;
            `}
          />
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 84px;
            `}
            onClick={handleDelayedCharge}
            data-loading={loading}
          >
            {loading ? null : "Submit"}
          </Button>
        </Footer>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        amount={chargeAmount}
        cardNumber={cardNumber}
        setAmount={setChargeAmount}
        setDetails={setChargeDetails}
        type="charge"
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        amount={chargeAmount}
        cardNumber={cardNumber}
        loading={loading}
        retryFunction={handleDelayedCharge}
        type="charge"
      />
    </>
  );
};

export default ModalDelayedCharge;
